import { render, staticRenderFns } from "./blockedUsers.vue?vue&type=template&id=42117a48&scoped=true&"
import script from "./blockedUsers.vue?vue&type=script&lang=js&"
export * from "./blockedUsers.vue?vue&type=script&lang=js&"
import style0 from "./blockedUsers.vue?vue&type=style&index=0&id=42117a48&ref=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42117a48",
  null
  
)

export default component.exports